var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view_container"},[_c('Header'),(!_vm.isSafari && !_vm.isIOS)?_c('AddIntroVideo'):_vm._e(),(_vm.isSafari && !_vm.isIOS)?_c('AddIntroVideoTwilio'):_vm._e(),(_vm.isIOS)?_c('AddIntroVideoWithFileUpload'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }